import { AiSearchDto, AiSearchData } from '../../../../shared/models';

export function buildAiSearchData(dto: AiSearchDto | null): AiSearchData | null {
  if (!dto) {
    return null;
  }

  const { id, generalText, vacancyText, similarLinkedinUrl, similarWfUrls, adjustments } = dto;
  const formData: AiSearchData = {};

  if (id) {
    formData.id = id;
  }

  if (generalText) {
    formData.generalText = generalText;
  }

  if (vacancyText) {
    formData.vacancyText = vacancyText;
  }

  if (similarLinkedinUrl?.length) {
    formData.similarLinkedinUrls = similarLinkedinUrl;
  }

  if (similarWfUrls?.length) {
    formData.similarWfUrls = similarWfUrls;
  }

  if (adjustments?.length) {
    formData.adjustments = adjustments;
  }

  // Note: file property is not mapped as it's not returned in GET responses

  return formData;
}

export function buildAiSearchDto(formData: AiSearchData): AiSearchDto {
  const dto: AiSearchDto = {};

  if (formData.id) {
    dto.id = formData.id;
  }

  if (formData.generalText) {
    dto.generalText = formData.generalText;
  }

  if (formData.similarLinkedinUrls?.length) {
    dto.similarLinkedinUrl = formData.similarLinkedinUrls;
  }

  if (formData.similarWfUrls?.length) {
    dto.similarWfUrls = formData.similarWfUrls;
  }

  if (formData.vacancyText) {
    dto.vacancyText = formData.vacancyText;
  }

  return dto;
}
